import jsPDF from 'jspdf'
import 'jspdf-autotable'

const generatePDF = (emprestimos, logs) => {
  const doc = new jsPDF('a4')

  // Configuração de cores
  const primaryColor = [41, 128, 185] // Azul
  const secondaryColor = [52, 152, 219] // Azul claro
  const successColor = [39, 174, 96] // Verde
  const dangerColor = [231, 76, 60] // Vermelho
  const warningColor = [241, 196, 15] // Amarelo
  const textColor = [44, 62, 80] // Cinza escuro

  // Cabeçalho com estilo
  doc.setFillColor(...primaryColor)
  doc.rect(0, 0, 210, 35, 'F')

  // Título principal
  doc.setTextColor(255, 255, 255)
  doc.setFontSize(20)
  doc.setFont('helvetica', 'bold')
  let titulo = 'RELATORIO DE EMPRESTIMOS'
  if (emprestimos[1]) {
    if (emprestimos[0].nome != emprestimos[1].nome) {
      titulo += ' - GERAL'
    } else {
      titulo += ' - ' + emprestimos[0].nome.toUpperCase()
    }
  } else {
    titulo += ' - ' + emprestimos[0].nome.toUpperCase()
  }

  doc.text(titulo, 14, 20)

  // Subtítulo com data
  doc.setFontSize(12)
  doc.setFont('helvetica', 'normal')
  const dataAtual = new Date().toLocaleDateString('pt-BR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
  doc.text(`Gerado em: ${dataAtual}`, 14, 30)

  // Reset cor do texto
  doc.setTextColor(...textColor)

  // Título da seção
  doc.setFontSize(16)
  doc.setFont('helvetica', 'bold')
  doc.text('DETALHAMENTO DOS EMPRESTIMOS', 14, 50)

  // Tabela de Empréstimos com nova coluna
  const tableColumnEmprestimos = [
    'Nome',
    'Valor',
    'Juros (%)',
    'A Receber',
    'Vencimento',
    'Meses Atraso',
    'Juros Diarios',
    'Status'
  ]
  const tableRowsEmprestimos = []

  let totalValor = 0
  let totalReceber = 0
  let totaValorJurosDiarios = 0
  let totalValorJurosPercentualMensal = 0
  let totalValorJurosSomados = 0

  emprestimos.forEach(emp => {
    const valor = Number(emp.valor)
    const jurosPercentual = Number(emp.juros)
    // Sempre aplicar 30% sobre o valor base
    const baseSurcharge = valor * (jurosPercentual / 100)

    // Calcular dias em atraso e meses completos (cada 30 dias)
    let diasAtraso = 0
    let mesesCompletos = 0
    let valorJurosDiarios = 0
    if (emp.dataPagamento) {
      const hoje = new Date()
      const dataPgto = new Date(emp.dataPagamento + 'T00:00:00')
      if (dataPgto < hoje) {
        const diffTime =
          hoje.setHours(0, 0, 0, 0) - dataPgto.setHours(0, 0, 0, 0)
        diasAtraso = Math.floor(diffTime / (1000 * 60 * 60 * 24))
        mesesCompletos = Math.floor(diasAtraso / 30)
        valorJurosDiarios = diasAtraso * (Number(emp.valor_jurosdiarios) || 0)
      }
    }

    // Juros percentuais acumulados por meses completos: 30% por mês completo
    const valorJurosPercentual =
      valor * (mesesCompletos * (jurosPercentual / 100))
    console.log('Valor Juros Percentual:', valorJurosPercentual)
    console.log('Valor Juros Diarios:', valorJurosDiarios)
    console.log('valor base surcharge:', baseSurcharge)
    console.log('Valor base:', valor)
    const total =
      valor + baseSurcharge + valorJurosPercentual + valorJurosDiarios
    totalValor += valor
    totalReceber += total
    totalValorJurosPercentualMensal += valorJurosPercentual
    totaValorJurosDiarios += valorJurosDiarios
    totalValorJurosSomados =
      totalValorJurosPercentualMensal + totaValorJurosDiarios

    let statusText = emp.status || 'Pendente'
    if (mesesCompletos > 0 || diasAtraso > 0) {
      statusText = 'Em Atraso'
    } else if (emp.status === 'Pago') {
      statusText = 'Pago'
    } else if (emp.status === 'Cancelado') {
      statusText = 'Cancelado'
    }
    tableRowsEmprestimos.push([
      emp.nome,
      `R$ ${valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`,
      `${jurosPercentual}%`,
      `R$ ${total.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`,
      emp.dataPagamento || 'N/A',
      mesesCompletos > 0
        ? `${mesesCompletos} mes${mesesCompletos > 1 ? 'es' : ''}`
        : 'Em dia',
      valorJurosDiarios > 0
        ? `R$ ${valorJurosDiarios.toLocaleString('pt-BR', {
            minimumFractionDigits: 2
          })} (${diasAtraso} dias)`
        : 'Em dia',
      statusText
    ])
  })

  // Configuração da tabela
  doc.autoTable({
    head: [tableColumnEmprestimos],
    body: tableRowsEmprestimos,
    startY: 55,
    theme: 'striped',
    headStyles: {
      fillColor: primaryColor,
      textColor: [255, 255, 255],
      fontSize: 10,
      fontStyle: 'bold',
      halign: 'center'
    },
    bodyStyles: {
      fontSize: 9,
      textColor: textColor
    },
    alternateRowStyles: {
      fillColor: [248, 249, 250]
    },
    columnStyles: {
      0: { halign: 'left' },
      1: { halign: 'right' },
      2: { halign: 'center' },
      3: { halign: 'right' },
      4: { halign: 'center' },
      5: { halign: 'center' },
      6: { halign: 'right' },
      7: { halign: 'center' }
    }
  })

  // Seção de totais
  const yPosition = doc.autoTable.previous.finalY + 15

  doc.setFillColor(248, 249, 250)
  doc.rect(10, yPosition - 5, 190, 50, 'F')

  doc.setFontSize(14)
  doc.setFont('helvetica', 'bold')
  doc.setTextColor(...primaryColor)
  doc.text('RESUMO FINANCEIRO', 14, yPosition + 5)

  doc.setFontSize(11)
  doc.setFont('helvetica', 'normal')
  doc.setTextColor(...textColor)

  doc.text(
    `Valor Total Emprestado: R$ ${totalValor.toLocaleString('pt-BR', {
      minimumFractionDigits: 2
    })}`,
    14,
    yPosition + 15
  )
  doc.text(
    `Juros Diarios Acumulados: R$ ${totaValorJurosDiarios.toLocaleString(
      'pt-BR',
      { minimumFractionDigits: 2 }
    )}`,
    14,
    yPosition + 23
  )
  doc.text(
    `Juros Mensais Acumulados: R$ ${totalValorJurosPercentualMensal.toLocaleString(
      'pt-BR',
      { minimumFractionDigits: 2 }
    )}`,
    14,
    yPosition + 31
  )

  doc.setFont('helvetica', 'bold')
  doc.setTextColor(...warningColor)
  doc.text(
    `Total de Juros: R$ ${totalValorJurosSomados.toLocaleString('pt-BR', {
      minimumFractionDigits: 2
    })}`,
    14,
    yPosition + 39
  )

  doc.setFontSize(12)
  doc.setTextColor(...successColor)
  doc.text(
    `TOTAL A RECEBER: R$ ${totalReceber.toLocaleString('pt-BR', {
      minimumFractionDigits: 2
    })}`,
    14,
    yPosition + 47
  )

  // Seção de logs
  const logYPosition = doc.autoTable.previous.finalY + 70

  if (logYPosition > 250) {
    doc.addPage()
    const newPageY = 20

    doc.setFontSize(16)
    doc.setFont('helvetica', 'bold')
    doc.setTextColor(...primaryColor)
    doc.text('HISTORICO DE TRANSACOES', 14, newPageY)
    const tableColumnLogs = ['Data', 'Usuario', 'Acao', 'Valor', 'Juros']
    const tableRowsLogs = logs.map(({ data, nome, acao, valor, juros }) => [
      data || 'N/A',
      nome || 'N/A',
      acao || 'N/A',
      valor
        ? `R$ ${Number(valor).toLocaleString('pt-BR', {
            minimumFractionDigits: 2
          })}`
        : 'N/A',
      juros ? `${juros}%` : 'N/A'
    ])

    doc.autoTable({
      head: [tableColumnLogs],
      body: tableRowsLogs,
      startY: newPageY + 10,
      theme: 'striped',
      headStyles: {
        fillColor: secondaryColor,
        textColor: [255, 255, 255],
        fontSize: 10,
        fontStyle: 'bold',
        halign: 'center'
      },
      bodyStyles: {
        fontSize: 9,
        textColor: textColor
      },
      alternateRowStyles: {
        fillColor: [248, 249, 250]
      }
    })
  } else {
    doc.setFontSize(16)
    doc.setFont('helvetica', 'bold')
    doc.setTextColor(...primaryColor)
    doc.text('HISTORICO DE TRANSACOES', 14, logYPosition)

    const tableColumnLogs = ['Data', 'Usuario', 'Acao', 'Valor', 'Juros']
    const tableRowsLogs = logs.map(({ data, nome, acao, valor, juros }) => [
      data || 'N/A',
      nome || 'N/A',
      acao || 'N/A',
      valor
        ? `R$ ${Number(valor).toLocaleString('pt-BR', {
            minimumFractionDigits: 2
          })}`
        : 'N/A',
      juros ? `${juros}%` : 'N/A'
    ])

    doc.autoTable({
      head: [tableColumnLogs],
      body: tableRowsLogs,
      startY: logYPosition + 10,
      theme: 'striped',
      headStyles: {
        fillColor: secondaryColor,
        textColor: [255, 255, 255],
        fontSize: 10,
        fontStyle: 'bold',
        halign: 'center'
      },
      bodyStyles: {
        fontSize: 9,
        textColor: textColor
      },
      alternateRowStyles: {
        fillColor: [248, 249, 250]
      }
    })
  }

  // Rodapé
  const finalY = doc.autoTable.previous.finalY || 280
  if (finalY < 270) {
    doc.setFontSize(8)
    doc.setTextColor(150, 150, 150)
    doc.text(
      'Sistema de Gestao de Emprestimos - Relatorio gerado automaticamente',
      14,
      285
    )
    doc.text(`Processado em: ${new Date().toLocaleString('pt-BR')}`, 14, 290)
  }

  // Salvar arquivo
  let nomeArquivo = ''
  if (emprestimos[1]) {
    if (emprestimos[0].nome != emprestimos[1].nome) {
      nomeArquivo = 'relatorio_emprestimos_GERAL.pdf'
    } else {
      nomeArquivo = `relatorio_emprestimos_${emprestimos[0].nome.replace(
        /\s+/g,
        '_'
      )}.pdf`
    }
  } else {
    nomeArquivo = `relatorio_emprestimos_${emprestimos[0].nome.replace(
      /\s+/g,
      '_'
    )}.pdf`
  }

  doc.save(nomeArquivo)
}

export const BackupButton = ({ emprestimos, logs }) => {
  return (
    <button
      className="px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white font-semibold rounded-lg shadow-lg hover:from-blue-700 hover:to-blue-800 transition-all duration-300 transform hover:scale-105 flex items-center gap-2"
      onClick={() => generatePDF(emprestimos, logs)}
    >
      <span>📄</span>
      <span>Gerar Relatório PDF</span>
    </button>
  )
}

export default generatePDF
